import React, { ReactNode } from 'react';
import './Box.less';

type Props = {
  header?: ReactNode;
  content?: ReactNode;
};

const Box: React.FC<Props> = ({ header, content }) => {
  return (
    <div className="Box-body">
      {header && <div className="Box-header">{header}</div>}
      {content && <div className="Box-content">{content}</div>}
    </div>
  );
};

export default Box;
